import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

/** @jsxImportSource @emotion/react */
import { AmplitudeEventNames, sendAmplitudeData } from "@vc-workspace/utils-amplitude";
import { INTERNAL_NAVIGATION_UTM_MEDIUM, PageTypes, UtmParams } from "@vc-workspace/utils-constants";
import { Typography } from "@vc-workspace/utils-typography";
import { useRouter } from "next/router";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { containerStyles, nextNavStyles, prevNavStyles, viewMoreCardContainer, viewMoreOverlay, viewMoreImage } from "./shop-catalogue-section.module.style";
import { ButtonBack, ButtonNext, CarouselProvider, Slide, Slider } from "pure-react-carousel";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { getDisplayImageObj } from "@vc-workspace/utils-helpers";
import 'simplebar/dist/simplebar.min.css';
import { useState } from "react";
import ProductCard from "../product-card/product-card";
/* eslint-disable-next-line */

var ViewMoreCard = function ViewMoreCard(_ref) {
  var image = _ref.image,
      onClick = _ref.onClick;
  var displayImage = getDisplayImageObj(image, "2");
  return _jsxs("div", {
    css: viewMoreCardContainer,
    onClick: onClick,
    children: [_jsx("img", {
      src: displayImage.url,
      className: "h-full w-full object-cover",
      css: viewMoreImage
    }), _jsx("div", {
      css: viewMoreOverlay,
      children: _jsxs(Typography, {
        type: "SubHeading1",
        color: "white",
        children: [_jsx("span", {
          children: "View All"
        }), " ", _jsx(ArrowRightAltIcon, {})]
      })
    })]
  });
};

export function ShopCatalogueSection(props) {
  var _useState = useState(false),
      showPrev = _useState[0],
      togglePrev = _useState[1];

  var router = useRouter();

  function onViewMoreClick() {
    sendAmplitudeData(AmplitudeEventNames.VIEW_FULL_CATALOGUE, {
      shop_name: props.shop.name,
      shop_id: props.shop._id,
      source: "Shop Collection Section",
      source_name: props.catalogue.name
    });
    router.push({
      pathname: "/".concat(props.shop.slug, "/collection/").concat(props.catalogue.slug),
      query: {
        utm_medium: INTERNAL_NAVIGATION_UTM_MEDIUM
      }
    });
  }

  if (!props.sias || !props.sias.length) {
    return null;
  }

  function onNextClick() {
    togglePrev(true);
  }

  return _jsxs("div", {
    className: props.context.isMobileView ? "pt-8" : "pt-16",
    children: [_jsxs("div", {
      className: "pure-g ".concat(props.context.isMobileView ? "pb-6" : "pb-8"),
      children: [_jsx("div", {
        className: "pure-u-2-3",
        children: _jsx(Typography, {
          type: props.context.isMobileView ? "Headline_H3" : "Headline_H2",
          color: "nero",
          className: "uppercase",
          bold: true,
          children: props.catalogue.name
        })
      }), props.hasMoreProducts ? _jsx("div", {
        className: "pure-u-1-3 text-right",
        children: _jsxs(Typography, {
          type: "Body1",
          className: "pt-2 flex items-center justify-end",
          onClick: onViewMoreClick,
          color: "dim_grey",
          inline: true,
          children: [_jsx("span", {
            children: "View All"
          }), " ", _jsx(ArrowRightAltIcon, {})]
        })
      }) : null]
    }), !props.context.isMobileView ? _jsx("div", {
      className: "relative",
      children: _jsxs(CarouselProvider, {
        naturalSlideWidth: 200,
        naturalSlideHeight: 300,
        visibleSlides: 7.2,
        infinite: true,
        totalSlides: props.hasMoreProducts ? props.sias.length + 1 : props.sias.length,
        css: containerStyles,
        children: [_jsxs(Slider, {
          style: {
            height: 'inherit'
          },
          children: [props.sias.map(function (sia, index) {
            return _jsx(Slide, {
              index: index,
              children: _jsx(ProductCard, {
                sia: sia,
                context: props.context,
                sourceName: props.catalogue.name,
                sourceType: PageTypes.MARKETPLACE_SHOP_PAGE,
                disableVCUtm: props.context.query[UtmParams.UTM_MEDIUM] !== INTERNAL_NAVIGATION_UTM_MEDIUM,
                cardRowPosition: props.cataloguePosition + 1
              })
            }, sia._id);
          }), props.hasMoreProducts ? _jsx(Slide, {
            index: props.sias.length,
            children: _jsx(ViewMoreCard, {
              image: props.sias[0].itemDetail.images[0],
              onClick: onViewMoreClick
            })
          }, "view more ".concat(props.catalogue._id)) : null]
        }), props.sias.length > 6 ? _jsxs(_Fragment, {
          children: [showPrev ? _jsx(ButtonBack, {
            children: _jsx("div", {
              css: prevNavStyles,
              children: _jsx(ChevronLeftIcon, {})
            })
          }) : null, _jsx(ButtonNext, {
            onClick: onNextClick,
            children: _jsx("div", {
              css: nextNavStyles,
              children: _jsx(ChevronRightIcon, {})
            })
          })]
        }) : null]
      })
    }) : _jsxs("div", {
      css: containerStyles,
      children: [props.sias.map(function (sia) {
        return _jsx("div", {
          className: "inline-block mr-6",
          children: _jsx(ProductCard, {
            sia: sia,
            context: props.context,
            sourceName: props.catalogue.name,
            sourceType: PageTypes.MARKETPLACE_SHOP_PAGE,
            disableVCUtm: props.context.query[UtmParams.UTM_MEDIUM] !== INTERNAL_NAVIGATION_UTM_MEDIUM
          }, sia._id)
        }, sia._id);
      }), props.hasMoreProducts ? _jsx(ViewMoreCard, {
        image: props.sias[0].itemDetail.images[0],
        onClick: onViewMoreClick
      }) : null]
    })]
  });
}
export default ShopCatalogueSection;